import React from 'react';

import {useLocation, useMatch, useParams} from "react-router-dom";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BaseMatchModel} from "./models/base-match-model";
// import {RouterController} from "./router-controller";
// import {RouteModel} from "./models/route-model";
import {IOC} from "../../../infrastructure/ioc";
import {Type} from "../../../infrastructure/type";
import {UseIoC} from "../composers/composer-plugins/use-ioc";

export class WithRouterProps extends BaseProps {
  match: BaseMatchModel;
  location: Object;
  history: Object;
  ioc: IOC;
}

export const WithRouter = (route) => ((Component) => UseIoC()((props: WithRouterProps) => {
  const location = useLocation();
  const match = useMatch(decodeURI(location.pathname));
  const params = useParams();
  const matchType: Type<BaseMatchModel> = route?.config.matchType || BaseMatchModel;

  const additionalProps = {
    ...props,
    location,
    match: new matchType(params, route.config.path, match.pathname, location.hash, route.config?.parent)
  }

  return <Component {...additionalProps} />;
}));
